import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";
import { ToastMessages } from "../../../../components/toasts/toastMessages";
import { CopyIcon } from "../../../../../shared/svg/copy-icon";

interface CopyDataCellProps {
  value: string;
  [key: string]: any;
}

export const CopyDataCell: React.FC<CopyDataCellProps> = ({ value }) => {
  return (
    <>
      <div
        className="copy-data-container flex w-full max-w-full items-center gap-2 overflow-hidden"
        onClick={(e) => {
          e.stopPropagation(); // Prevent event bubbling to parent table cell
          navigator.clipboard.writeText(value);
          toast.success(ToastMessages.KEY_COPY_SUCCESS);
        }}
      >
        <div className="copy-text overflow-hidden truncate">
          {value === "" ? "--" : value}
        </div>
        {value && <CopyIcon />}
      </div>
    </>
  );
};

export default CopyDataCell;
